import React, { useState, useEffect, Fragment } from "react";
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from './../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2'
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import PageTitle from "../../Components/PageTitle.js";
import "react-toastify/dist/ReactToastify.css";
import JoditEditor from 'jodit-react';
import { joditToolbarReadOnly } from './../../Helpers/JoditToolbar.js';
import { decodeToken, isExpired } from "react-jwt";

const MesajAc = () => {
    useEffect(() => {
        getData();
    }, []);

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [data, setData] = useState(null);
    const [kimText, setKimText] = useState('');
    const [params, setParams] = useState('');

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    const getData = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Ayarlar - Kullanıcılar - Mesajlaşma");

        setYetkiGor(tempYetkiGor);

        if (tempYetkiGor === true){
            const paramsTemp = window.location.pathname.toLowerCase().replace("/mesaj/mesajac/", "");

            const gelenGiden = paramsTemp.split("/")[0];
            const id = paramsTemp.split("/")[1];

            setParams(paramsTemp);

            setKimText(gelenGiden === "1" ? "Kimden" : (gelenGiden === "2" ? "Kime" : "Kişiler"));

            const result = await axios.get(settings.ApiUrl + 'Mesaj/GetMesaj/' + gelenGiden + "/" + id , { headers: AuthService.getHeaders() });

            if (result) {
                if (result.data.success === true) {

                    const resultOku = await axios.post(settings.ApiUrl + 'Mesaj/UpdateMesajGonderilenKisiOkundu/', result.data.value, { headers: AuthService.getHeaders() });

                    if (resultOku) {
                        if (resultOku.data.success === true) {
                            setData(result.data.value);

                            document.getElementById('btnBildirimYenile').click();
                        }
                    }
                }
            }
        }
    }

    return (

        <Fragment>

            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            <PageTitle></PageTitle>

            {

                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            data ?
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <div className="input-group input-group-sm">
                                            <label className="input-group-text" id="lblKim" style={{ width: "80px" }}>{kimText}</label>
                                            <div aria-describedby="lblKim" className="form-control form-control-sm">{data.kim}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 mb-3">
                                        <div className="input-group input-group-sm">
                                            <label className="input-group-text" id="lblZaman" style={{ width: "80px" }}>Tarih</label>
                                            <div aria-describedby="lblZaman" className="form-control form-control-sm">{moment(data.zaman).format('DD.MM.YYYY HH:mm')}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <div className="input-group input-group-sm">
                                            <label className="input-group-text" id="lblKonu" style={{ width: "80px" }}>Konu</label>
                                            <div aria-describedby="lblKonu" className="form-control form-control-sm">{data.konu}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-12 mb-3">
                                        <div className="input-group input-group-sm">
                                            <label className="input-group-text" id="lblIcerik" style={{ width: "80px" }}>İçerik</label>
                                            <div aria-describedby="lblIcerik" className="form-control form-control-sm">
                                                <JoditEditor config={joditToolbarReadOnly} value={data.icerik}></JoditEditor>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <NavLink className="btn btn-sm btn-primary w-100" to={"/Mesaj/MesajYaz/1/" + params}><i className="bi bi-arrow-90deg-left"></i> Yanıtla</NavLink>
                                    </div>

                                    <div className="col-md-6">
                                        <NavLink className="btn btn-sm btn-success w-100" to={"/Mesaj/MesajYaz/2/" + params}><i className="bi bi-arrow-90deg-right"></i> İlet</NavLink>
                                    </div>
                                </div>
                                :
                                ""
                        :
                        ""                            
            }

        </Fragment>
    );
};

export default MesajAc;